import { ErrorHandler, Injectable } from '@angular/core';
 
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
 
  handleError(error: any): void {
 
    console.error('=== GLOBAL ERROR ===');
    console.error(error);  
 
    if (error?.stack) {
      console.error(error.stack);
    }
  }
}

/***  
This catches:
1.	White screen errors
2.	Null reference exceptions
3.	Runtime Angular errors
4.	Chunk loading failures

***/